module.exports = __webpack_public_path__ + "img/sousuo1.35c12c5b.svg";